export default __webpack_public_path__ + "static/media/quatro.d104ee47.png";